import React from 'react';
import Home from './HomeSvg';
import CloseDrawer from './CloseDrawer';
import Digiovi from './Digiovi';
import AccessLevels from './AccessLevelsSvg';
import DoorControls from './DoorControlsSvg';
import DoorsAndLocations from './DoorsAndLocationsSvg';
import Logout from './Logout';
import Persons from './PersonsSvg';
import Reports from './ReportsSvg';
import Schedules from './SchedulesSvg';
import TagTypes from './TagTypesSvg';
import Settings from './Settings';
import Add from './Add';
import Delete from './Delete';
import Save from './Save';
import Trash from './Trash';
import Lock from './Lock';

const SvgIcon = (props) => {
  const { icon, width } = props;
  const getIcon = (type) => {
    const icons = {
      Home: <Home {...props} />,
      CloseDrawer: <CloseDrawer {...props} />,
      AccessLevels: <AccessLevels {...props} />,
      Digiovi: <Digiovi {...props} />,
      DoorControls: <DoorControls {...props} />,
      DoorsAndLocations: <DoorsAndLocations {...props} />,
      Logout: <Logout {...props} />,
      Persons: <Persons {...props} />,
      Reports: <Reports {...props} />,
      Schedules: <Schedules {...props} />,
      TagTypes: <TagTypes {...props} />,
      Settings: <Settings {...props} />,
      Add: <Add {...props} />,
      Delete: <Delete {...props} />,
      Save: <Save {...props} />,
      Trash: <Trash {...props} />,
      Lock: <Lock {...props} />,
      default: <div {...props} />,
    };
    return icons[type] || icons['default'];
  };
  return <div style={{ display: 'flex', justifyContent: 'center', width: width ? width : 32 }}>{getIcon(icon)}</div>;
};

export default SvgIcon;
